<div
  #effectsColumn
  class="product-column-general product-effects"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'">
  <app-column-list-items
    [colVm]="colVm"
    [rowVm]="rowVm"
    [displayFormat]="displayFormat"
    [sectionColumnType]="colVm.columnType"
    [columnListLayoutModifierClass]="columnListLayoutModifierClass"
    [parentColumnElement]="effectsColumn">
  </app-column-list-items>
</div>
